import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import styled from 'styled-components';

const EvaluationTypesTable = () => {
  const createData1 = (type, description, reason) => {
    return { type, description, reason };
  };

  const rows1 = [
    createData1(
      'Speech-Only Evaluation',
      'A speech-only evaluation is an assessment that focuses on an individual’s speech production—how clearly they speak and how effectively they communicate with others. It does not include other areas such as academic or cognitive testing; the goal is simply to determine whether speech therapy may be beneficial and what type of support would best address their needs.',
      'When speech is difficult to understand, sounds are mispronounced, or when they use unusual sound patterns for their age.'
    ),
    createData1(
      'Comprehensive Language Evaluation',
      'A comprehensive language evaluation is a thorough assessment that looks at an individual’s overall expressive, receptive, and social language skills. It examines how well a person understands language (receptive skills), how effectively they use language to express themselves (expressive skills), and how they communicate and interact with others in social settings (social language).',
      'If he/she has trouble following directions, answering questions, putting words together, or using age-appropriate language.'
    ),
    createData1(
      'Feeding Evaluation',
      'How your child uses their mouth for eating, chewing, drinking, swallowing and oral movements needed for speech.',
      'Recommended for individuals who are picky eaters, have trouble chewing or swallowing, frequently gag, or show concerns with oral motor skills. It’s also helpful for those with a very limited variety of foods or strong preferences about food types and textures.'
    ),
    createData1(
      'Literacy & Academic Evaluations',
      'A literacy and academic evaluation looks at how a child reads, writes, and understands language in school settings. It helps identify strengths and challenges in skills like reading comprehension, spelling, writing, and overall learning. The results guide parents and teachers in understanding how the child learns best and what supports—like reading programs or classroom strategies—may help them succeed academically.',
      'For children who struggle with reading, writing, spelling, or keeping up in school. It helps identify specific areas of difficulty and provides guidance on how to best support the child’s learning and confidence.'
    ),
  ];
  return (
    <div>
      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 650, padding: '10px' }}
          aria-label='simple table'
        >
          <TableHead>
            <TableRow>
              <TableCell
                align='center'
                sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}
              >
                Type of Evaluation
              </TableCell>
              <TableCell
                align='left'
                sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}
              >
                What It Looks At
              </TableCell>
              <TableCell
                align='left'
                sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}
              >
                When It's Recommended
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows1.map((row, idx) => (
              <TableRow
                key={`${idx}`}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <StyledTableCell
                  align='center'
                  sx={{
                    fontSize: '15px',
                    color: '#55b3a6ff',
                    fontWeight: '600',
                  }}
                >
                  {row.type}
                </StyledTableCell>
                <StyledTableCell align='left' sx={{ fontSize: '15px' }}>
                  {row.description}
                </StyledTableCell>
                <StyledTableCell align='left' sx={{ fontSize: '15px' }}>
                  {row.reason}
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default EvaluationTypesTable;

export const StyledTableCell = styled(TableCell)`
  @media (min-width: 375px) and (max-width: 768px) {
    font-size: 13px !important;
  }
`;
